import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

export const INTERNAL_ADMIN_PERMISSION_LEVELS = [
  'admin_read',
  'admin',
  'admin_mcp_write',
] as const;

export const zodPermissionLevelsSchema = z.enum([
  ...INTERNAL_ADMIN_PERMISSION_LEVELS,
  'external_admin', // Limited 3rd party staff => HAS (limited) admin app access
  'user', // Regular customer user => NO admin app access
  'service_account', // Per-company machine/API account => NO admin app access
  'vestigas_support_account', // VESTIGAS support account for customer app => NO admin app access
  'backend', // Intended service-to-service account => NO admin app access
  'iv_ai_agent', // Machine account for invoice AI agents => NO admin app access
]);

export const zodCertificateRoleSchema = z.enum([
  'supplier',
  'carrier',
  'recipient',
  'buyer',
  'on_behalf_supplier',
  'on_behalf_carrier',
  'on_behalf_buyer',
  'on_behalf_recipient',
  'on_behalf_seller',
]);

// Flags with override semantics can be null: a pg_dln_* read path then inherits the
// company account, and agent_chat is disabled.
export const zodFeatureFlagsUserSchema = z.record(
  z.string(),
  z.boolean().nullable(),
);

export const zodUserSettingsSchema = z.object({
  featureFlags: zodFeatureFlagsUserSchema,
  language: z.string().min(2).nullable(),
});

export const zodMyUserResponseSchema = z.object({
  companyId: z.uuid(),
  email: EmailSchema.nullable(),
  firstName: z.string().nullable(),
  id: z.uuid(),
  isActive: z.boolean(),
  isSynced: z.boolean().optional(),
  isVestigasSupport: z.boolean().default(false),
  lastName: z.string().nullable(),
  permissionLevel: zodPermissionLevelsSchema.nullable(),
  permittedSignatureTypes: z.array(zodCertificateRoleSchema).nullable(),
  position: z.string().nullable(),
  settings: zodUserSettingsSchema,
  syncKey: z.string().nullable(),
  userType: zodCertificateRoleSchema.nullable(),
});
